import { ArrowRightIcon, CubeIcon } from '@heroicons/react/24/outline';
import { CARD_CLASS } from '../browserStyles';

export function ScansShortcut({ onOpen }: { onOpen: () => void }) {
    return (
        <button
            type="button"
            onClick={onOpen}
            className={`${CARD_CLASS} group flex w-full items-center gap-3 px-3.5 py-3 text-left transition-[border-color,box-shadow] hover:border-gray-300 hover:shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-400`}
        >
            <span className="grid h-[34px] w-[34px] shrink-0 place-items-center rounded-lg bg-gray-100 text-gray-700">
                <CubeIcon className="h-[18px] w-[18px]" aria-hidden="true" />
            </span>
            <span className="flex min-w-0 flex-1 flex-col">
                <span className="text-[13px] font-semibold text-gray-900">
                    Scans, 3D model and files
                </span>
                <span className="truncate text-[12px] text-gray-500">
                    Model views, screen captures and downloads
                </span>
            </span>
            <span className="inline-flex shrink-0 items-center gap-1 text-[12px] font-semibold text-gray-600 transition-colors group-hover:text-gray-900">
                Open Scans
                <ArrowRightIcon className="h-3.5 w-3.5" aria-hidden="true" />
            </span>
        </button>
    );
}
